import React from 'react';
import { SymbolChart } from '../../../platform/tradingview';
import { Link } from 'react-router-dom';
export const pct = n => n === null || n === undefined ? '—' : `${(Number(n) * 100).toFixed(2)}%`;
export function Picks({
  selections,
  result,
  prices = [],
  chart
}) {
  return <div className="ss-table"><table><thead><tr><th>Rank</th><th>Symbol</th><th>Confidence</th><th>Thesis / risks</th>{result && <><th>Start</th><th>End</th><th>Return</th><th>Alpha vs SPY</th><th>Outcome</th></>}</tr></thead><tbody>{selections.map(s => {
          const r = result?.selections.find(x => x.symbol === s.symbol),
            p = prices.find(x => x.symbol === s.symbol);
          return <tr key={s.symbol}><td>{s.rank}</td><td><SymbolChart symbol={s.symbol} build={chart?.build(s.symbol)} advice={chart?.advice} /></td><td>{s.confidence}%</td><td>{s.rationale}</td>{result && <><td>{p?.start_close}</td><td>{p?.end_close}</td><td>{pct(r?.security_return)}</td><td>{pct(r?.alpha)}</td><td>{r?.alpha === 0 ? 'Tie' : r?.outperform ? 'Outperform' : 'Underperform'}</td></>}</tr>;
        })}</tbody></table></div>;
}
export function Comparison({
  predictions
}) {
  return <div className="ss-table"><table><thead><tr><th>Model</th><th>Picks</th><th>Beat SPY</th><th>Hit rate</th><th>Return</th><th>SPY</th><th>Alpha</th><th>Best / worst</th></tr></thead><tbody>{predictions.map(p => <tr key={p.id}>
    <td><Link to={`/stock-selection/predictions/${p.id}`}>{p.model_name}</Link></td><td>5</td><td>{p.result ? `${p.result.beat_spy_count}/5` : 'Pending'}</td><td>{pct(p.result?.hit_rate)}</td><td>{pct(p.result?.portfolio_return)}</td><td>{pct(p.result?.spy_return)}</td><td>{pct(p.result?.portfolio_alpha)}</td><td>{p.result ? `${p.result.best_symbol} / ${p.result.worst_symbol}` : '—'}</td>
  </tr>)}</tbody></table></div>;
}
